import BoxStoreNumber from "./_components/BoxStoreNumber";

const StartPage = () => <BoxStoreNumber />;

export default StartPage;
